import React from 'react';
import { Personnel, roleStyles, statusStyles } from '../liveTrackingTypes';
import styles from './PersonnelCard.module.css';

interface PersonnelCardProps {
  person: Personnel;
}

export const PersonnelCard: React.FC<PersonnelCardProps> = ({ person }) => {
  const role   = roleStyles[person.role];
  const status = statusStyles[person.status];
  const progress = Math.round((person.stopsCompleted / person.totalStops) * 100);
  const barColor = person.status === 'Driving' ? '#2563EB' : person.status === 'At Store' ? '#EA580C' : '#9CA3AF';

  return (
    <div className={styles.card}>
      <div className={styles.top}>
        {/* Avatar */}
        <div className={styles.avatar} style={{ background: person.avatarBg }}>
          {person.initials}
        </div>

        {/* Info */}
        <div className={styles.info}>
          <div className={styles.nameRow}>
            <span className={styles.name}>{person.name}</span>
            <span className={styles.roleBadge} style={{ background: role.bg, color: role.color }}>
              {person.role}
            </span>
          </div>
          <span className={styles.route}>{person.route}</span>
        </div>

        {/* Last seen */}
        <span className={styles.lastSeen}>{person.lastSeen}</span>
      </div>

      {/* Progress bar */}
      <div className={styles.progressRow}>
        <div className={styles.progressBg}>
          <div
            className={styles.progressFill}
            style={{ width: `${progress}%`, background: barColor }}
          />
        </div>
        <span className={styles.progressCount}>
          {person.stopsCompleted}/{person.totalStops}
        </span>
      </div>

      {/* Status */}
      <div className={styles.statusRow}>
        <span className={styles.statusDot} style={{ background: status.dot }} />
        <span className={styles.statusLabel} style={{ color: status.label }}>{person.status}</span>
      </div>
    </div>
  );
};
